export default __webpack_public_path__ + "static/media/pointer-cursor.e6933767.png";